var _path, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10N(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8657 11.1115C26.0436 11.9752 24.9114 12.5494 23.6289 12.6481C20.8757 12.86 18.4719 10.7998 18.2601 8.04647C18.2049 7.3298 18.3037 6.63681 18.5286 6C16.4237 7.00823 15.0476 9.23411 15.2374 11.7009C15.4842 14.9077 18.2838 17.3072 21.4906 17.0605C24.5955 16.8215 26.9437 14.1893 26.8657 11.1115Z",
    fill: "url(#paint0_linear_10214_702)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_10214_702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.127,
    y: 19.5444,
    width: 1.76471,
    height: 5.87295,
    rx: 0.882353,
    transform: "rotate(-30 20.127 19.5444)",
    fill: "url(#paint1_linear_10214_702)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_10214_702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.0657,
    y: 19.1497,
    width: 1.76471,
    height: 7.06637,
    rx: 0.882353,
    transform: "rotate(-30 17.0657 19.1497)",
    fill: "url(#paint2_linear_10214_702)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_10214_702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.7874,
    y: 20.0232,
    width: 1.76471,
    height: 6.58681,
    rx: 0.882353,
    transform: "rotate(-30 11.7874 20.0232)",
    fill: "url(#paint3_linear_10214_702)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_10214_702)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.6091,
    y: 19.7685,
    width: 1.76471,
    height: 5.85646,
    rx: 0.882353,
    transform: "rotate(-30 14.6091 19.7685)",
    fill: "url(#paint4_linear_10214_702)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_10214_702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8785 22.2596H9.06834C6.48619 22.2596 5 20.6073 5 18.5648C5 16.7964 6.12087 15.4015 7.78142 14.9282C8.07201 11.6155 10.7953 9.11633 14.0168 9.11633C16.4827 9.11633 18.5085 10.4531 19.6128 12.645C22.6267 12.645 24.8435 14.7041 24.8435 17.4357C24.8435 20.1424 22.6765 22.2596 19.8785 22.2596Z",
    fill: "#8E8E8E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0546 12.9262L19.2278 13.27H19.6128C22.3318 13.27 24.2185 15.0975 24.2185 17.4357C24.2185 19.7813 22.3474 21.6346 19.8785 21.6346H9.06834C7.91363 21.6346 7.06016 21.2677 6.49931 20.7279C5.93776 20.1873 5.625 19.4312 5.625 18.5648C5.625 17.0891 6.54742 15.9298 7.95272 15.5293L8.36643 15.4114L8.40402 14.9829C8.66693 11.9858 11.1264 9.74133 14.0168 9.74133C16.2311 9.74133 18.0494 10.9308 19.0546 12.9262Z",
    stroke: "#8E8E8E",
    strokeOpacity: 0.4,
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_10214_702",
    x: 7.14444,
    y: 5.67964,
    width: 30.4296,
    height: 31.9334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_10214_702",
    x: 4.08316,
    y: 5.28488,
    width: 31.0265,
    height: 32.9669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_10214_702",
    x: -1.19516,
    y: 6.15836,
    width: 30.7866,
    height: 32.5516,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_10214_702",
    x: 1.62662,
    y: 5.90367,
    width: 30.4216,
    height: 31.9191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.65263
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_10214_702",
    x: -15,
    y: -10.8837,
    width: 59.8435,
    height: 53.1432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_10214_702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_10214_702",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10214_702",
    x1: 18.5799,
    y1: 8.42329,
    x2: 27.4184,
    y2: 11.6191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10214_702",
    x1: 20.636,
    y1: 20.8292,
    x2: 22.1342,
    y2: 20.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10214_702",
    x1: 17.5747,
    y1: 20.6955,
    x2: 19.0778,
    y2: 20.8245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10214_702",
    x1: 12.2964,
    y1: 21.464,
    x2: 13.7978,
    y2: 21.6024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10214_702",
    x1: 15.1182,
    y1: 21.0496,
    x2: 16.6163,
    y2: 21.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EB3E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10N);
export default __webpack_public_path__ + "static/media/10n.e0a8c50c63f24b663d50bff8171abb95.svg";
export { ForwardRef as ReactComponent };